export default {
  Codigo: null,
  CodigoSolicitud: null,
  ItemProducto: null,
  CodigoEspecificacionTecnica: null,
  Descripcion: null,
  SolicitudProductoCantidad: [],
  Repeticion: null,
};

export const SolicitudProductoCantidad = {
  Codigo: null,
  CodigoSolicitudProducto: null,
  ItemCantidad: null,
  Cantidad: null,
};
